module.exports = __webpack_public_path__ + "imgs/flowhub.e2637236308be7f36933bed6b43ba802.jpg";